import './addUser.scss';
import { Contexts, } from 'modules/core/ContextProcessorService';
class AddUserController {
    static $inject = ['close', '$translate', '$state', 'ContextProcessorService', 'TenantService', 'BLIP_DOMAIN'];
    constructor(close, $translate, $state, ContextProcessorService, TenantService, BLIP_DOMAIN) {
        'ngInject';
        this.close = close;
        this.$translate = $translate;
        this.$state = $state;
        this.ContextProcessorService = ContextProcessorService;
        this.TenantService = TenantService;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
        this.permissionsValue = 1;
        this.userNotOnTenantErrorMessage = '';
        this.userNotOnTenantIfProceedingAddViewerErrorMessage = '';
        this.inexistentOrInactiveAccountErrorMessage = '';
        this.userInviteErrorMessage = '';
        this.setupSlider();
        this.setupTenantInformation();
    }
    addCustomUser() {
        this.$state.go('auth.application.detail.team.edit', {
            newUser: { email: this.userEmail },
        });
    }
    addUser() {
        const user = {
            email: this.userEmail,
            created: new Date(),
            isPending: true,
        };
        this.close({ user, permissionCode: this.permissionsValue });
    }
    async setupSlider() {
        const visualize = await this.$translate('application-team.addUserModal.slider.visualize');
        const custom = await this.$translate('application-team.addUserModal.slider.custom');
        const edit = await this.$translate('application-team.addUserModal.slider.edit');
        const admin = await this.$translate('application-team.addUserModal.slider.admin');
        this.sliderConfig = {
            options: {
                showTicksValues: true,
                showSelectionBar: true,
                stepsArray: [
                    { value: 1, legend: visualize },
                    { value: 0, legend: custom },
                    { value: 3, legend: edit },
                    { value: 4, legend: admin },
                ],
            },
        };
    }
    async setupTenantInformation() {
        this._currentUserIsContractAdmin = await this.TenantService.isContractAdmin(this.ContextProcessorService.currentUser.identity);
        if (this.ContextProcessorService.context === Contexts.Tenants) {
            const { name: tenantName } = this.ContextProcessorService.tenant;
            this.userNotOnTenantErrorMessage = await this.$translate('application-team.addUserModal.emailNotOnTenant', { tenantName });
            this.userNotOnTenantIfProceedingAddViewerErrorMessage = await this.$translate('application-team.addUserModal.emailNotOnTenantIfProceedingAddViewer');
            this.inexistentOrInactiveAccountErrorMessage = await this.$translate('application-team.addUserModal.inexistentOrInactiveAccountErrorMessage');
        }
    }
    async isEmailOnTenant() {
        this.isUserNotOnTenant = false;
        if (this.ContextProcessorService.context === Contexts.Tenants &&
            this.userForm.email.$valid) {
            const tenantId = this.ContextProcessorService.tenant.id;
            const userIdentity = `${encodeURIComponent(this.userEmail)}@${this.BLIP_DOMAIN}`;
            try {
                const tenantUser = await this.TenantService.getTenantUser(tenantId, userIdentity);
                if (tenantUser) {
                    this.userForm.$setValidity('emailNotOnTenant', true, this.userForm);
                    return;
                }
            }
            catch (err) {
                const jsonMsg = JSON.parse(err);
                this.isIconError = true;
                if (jsonMsg.reason.code === 67 && jsonMsg.reason.description.startsWith('User not found')) {
                    this.userInviteErrorMessage = this.inexistentOrInactiveAccountErrorMessage;
                    this.userForm.$setValidity('emailNotOnTenant', false, this.userForm);
                }
                else {
                    this.userInviteErrorMessage = this.userNotOnTenantErrorMessage;
                    if (this._currentUserIsContractAdmin) {
                        this.isIconError = false;
                        this.userInviteErrorMessage = this.userNotOnTenantIfProceedingAddViewerErrorMessage;
                    }
                    this.userForm.$setValidity('emailNotOnTenant', this._currentUserIsContractAdmin, this.userForm);
                }
                this.isUserNotOnTenant = true;
                console.error(err);
            }
        }
    }
}
AddUserController.$inject = ['close', '$translate', '$state', 'ContextProcessorService', 'TenantService', 'BLIP_DOMAIN'];
export default AddUserController;
